import {
  SEARCH_REINDEX_COMPLETED,
  SEARCH_REINDEX_STARTED,
  SUBMIT_SEARCH_REINDEX,
  SearchReindexActionTypes,
  SearchReindexCompletedAction,
  SearchReindexStartedAction,
  SearchReindexState,
  SubmitSearchReindexSuccessAction,
} from "./SearchReindexTypes";

const initialState: SearchReindexState = {
  running: null,
};

export const SearchReindexReducer = (
  state: SearchReindexState = initialState,
  action: SearchReindexActionTypes,
): SearchReindexState => {
  switch (action.type) {
    case SUBMIT_SEARCH_REINDEX.SUCCESS: {
      const { payload } = action as SubmitSearchReindexSuccessAction;
      // The started event carries the server's start time; keep it if it
      // arrived before the 202.
      if (state.running?.requestId === payload.requestId) {
        return state;
      }
      return {
        ...state,
        running: {
          requestId: payload.requestId,
          storeId: payload.storeId,
          startedAt: new Date().toISOString(),
        },
      };
    }
    case SEARCH_REINDEX_STARTED:
      return {
        ...state,
        running: (action as SearchReindexStartedAction).payload,
      };
    case SEARCH_REINDEX_COMPLETED:
      if (
        state.running?.requestId !==
        (action as SearchReindexCompletedAction).payload.requestId
      ) {
        return state;
      }
      return { ...state, running: null };
    default:
      return state;
  }
};
